var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNaira(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.14978 8.93605H12.3637M1.14978 5.71622H12.3637H1.14978Z",
    stroke: "#3A3A3A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.26001 13.0441C1.26001 13.5964 1.70772 14.0441 2.26001 14.0441C2.81229 14.0441 3.26001 13.5964 3.26001 13.0441H1.26001ZM11.2541 1.71919C11.2541 1.16691 10.8064 0.719193 10.2541 0.719193C9.70179 0.719193 9.25408 1.16691 9.25408 1.71919H11.2541ZM3.26001 13.0441V4.86992H1.26001V13.0441H3.26001ZM3.26001 4.86992L7.62014 11.0468L9.25408 9.8934L4.89395 3.71655L3.26001 4.86992ZM11.2541 9.8934V1.71919H9.25408V9.8934H11.2541ZM7.62014 11.0468C8.74548 12.641 11.2541 11.8448 11.2541 9.8934H9.25408L7.62014 11.0468ZM3.26001 4.86992L4.89395 3.71655C3.76861 2.12232 1.26001 2.91853 1.26001 4.86992H3.26001Z",
    fill: "#3A3A3A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNaira);
export default __webpack_public_path__ + "static/media/naira.27fba29a9775bfc98fb9fa7fce10ad4e.svg";
export { ForwardRef as ReactComponent };